// extracted by mini-css-extract-plugin
export default {"overlay":"Xx-z","bodyOpen":"Yx-z","content":"Zx-z","header":"_x-z","close":"ay-z","closeNoHeading":"by-z"};